import React from 'react'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import { Button, Table, Container, Columns, Column } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import { Switch } from '../../../../midasComponents'

import { getText } from '../../../../internal/TextLabels'
import {
  calculateActionSum,
  FormattedAmount,
} from '../../shared/transaction-utils'
import style from '../../shared/transactions.style'
import Tooltip from '../../../../internal/Tooltip'
import TransactionAddArticle from '../../TransactionAddArticle'
import { TransactionCartUIEcomTableHead } from './TransactionCartUIEcomTableHead'
import { TransactionCartUIEcomTableRow } from './TransactionCartUIEcomTableRow'
import { ActionTypes } from '../../../../util/transactionConstants'

const maxAmountSpanStyle = {
  display: 'block',
  paddingTop: '0.4rem',
  fontSize: '11px',
  fontWeight: 'bold',
}

const hidden = {
  display: 'none',
}

class TransactionCartUIEcom extends React.PureComponent {
  isToggleSumOperationsDisabled() {
    const { action: { type } = {} } = this.props || {}
    const { CREDIT, DEBIT } = ActionTypes
    return !(type === CREDIT || type === DEBIT)
  }

  render() {
    return (this.props.cartArticles && this.props.cartArticles.length > 0) ||
      this.props.terminalTransaction ? (
      <Container>
        <Columns>
          <Column col12>
            <div
              style={{
                overflow: 'auto',
                marginBottom: '1rem',
                width: '100%',
              }}
            >
              <div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        paddingRight: '.75rem',
                        marginTop: '1rem',
                      }}
                    >
                      {getText('transactions.transaction.sumAction.number')}
                    </div>
                    <Switch
                      id="toggleSumOperations"
                      checked={this.props.sumOperations}
                      onChange={() => {
                        this.props.toggleSumOperations()
                      }}
                      disabled={this.isToggleSumOperationsDisabled()}
                      text={getText('transactions.transaction.sumAction.sum')}
                      role="presentation"
                    />
                  </div>
                  <div
                    disabled={this.isToggleSumOperationsDisabled()}
                    style={{
                      cursor: 'pointer',
                      userSelect: 'none',
                    }}
                    onClick={this.props.toggleSumOperations}
                    role="presentation"
                  />
                </div>
              </div>
              <Table disableHover dataCy="article-table">
                <TransactionCartUIEcomTableHead {...this.props} />
                <tbody style={{ whiteSpace: 'wrap' }}>
                  {this.props.cartArticles &&
                    this.props.cartArticles.map((article, index) => (
                      <TransactionCartUIEcomTableRow
                        {...this.props}
                        key={article.rowId}
                        article={article}
                        index={index}
                      />
                    ))}
                </tbody>
                <tfoot style={{ whiteSpace: 'nowrap' }}>
                  <tr
                    style={{
                      background: '#f4f4f4',
                      borderTop: '2px solid #ccc',
                      borderBottom: '2px solid #ccc',
                    }}
                  >
                    <th
                      className={midas.textLeft}
                      style={{
                        ...style.tableHead,
                        verticalAlign: 'middle',
                      }}
                      colSpan="4"
                    >
                      {getText('transactions.transaction.total')}
                    </th>
                    <td className={midas.textRight}>
                      {this.props.cartStatus &&
                        FormattedAmount(this.props.cartStatus.totalOrderAmount)}
                    </td>
                    <td className={midas.textRight}>
                      {this.props.cartStatus &&
                        FormattedAmount(
                          this.props.cartStatus.totalOrderAmountVat,
                        )}
                    </td>
                    <td />
                    <td
                      style={{
                        borderLeft: '2rem solid white',
                        textAlign: 'center',
                      }}
                    >
                      <Conditional.Group>
                        <Conditional
                          when={
                            this.props.action.type === ActionTypes.DEBIT &&
                            this.props.cartStatus
                          }
                        >
                          {FormattedAmount(
                            calculateActionSum(
                              this.props.cartArticles,
                              this.props.sumOperations,
                            ),
                          )}
                        </Conditional>
                        <Conditional.NoMatch>
                          {this.props.cartStatus &&
                            FormattedAmount(
                              this.props.cartStatus.debitedAmount,
                            )}
                        </Conditional.NoMatch>
                      </Conditional.Group>
                      <Conditional
                        when={this.props.action.type === ActionTypes.DEBIT}
                      >
                        <span style={maxAmountSpanStyle}>
                          ({getText('transactions.transaction.sumAction.max')}
                          {this.props.cartStatus.debitableAmount.toFixed(2)}
                          {getText('default.currency')})
                        </span>
                      </Conditional>
                    </td>
                    <td
                      style={{
                        borderLeft: '1rem solid white',
                        textAlign: 'center',
                      }}
                    >
                      <Conditional.Group>
                        <Conditional
                          when={
                            this.props.action.type === ActionTypes.CREDIT &&
                            this.props.cartStatus
                          }
                        >
                          {FormattedAmount(
                            calculateActionSum(
                              this.props.cartArticles,
                              this.props.sumOperations,
                            ),
                          )}
                        </Conditional>
                        <Conditional.NoMatch>
                          {this.props.cartStatus &&
                            FormattedAmount(
                              this.props.cartStatus.creditedAmount,
                            )}
                        </Conditional.NoMatch>
                      </Conditional.Group>
                      <Conditional
                        when={this.props.action.type === ActionTypes.CREDIT}
                      >
                        <span style={maxAmountSpanStyle}>
                          ({getText('transactions.transaction.sumAction.max')}
                          {this.props.cartStatus.creditableAmount.toFixed(2)}
                          {getText('default.currency')})
                        </span>
                      </Conditional>
                    </td>
                    <td
                      style={{
                        borderLeft: '1rem solid white',
                        textAlign: 'center',
                      }}
                    >
                      <Conditional.Group>
                        <Conditional
                          when={
                            this.props.action.type === ActionTypes.ANNUL &&
                            this.props.cartStatus
                          }
                        >
                          {FormattedAmount(
                            calculateActionSum(this.props.cartArticles),
                          )}
                        </Conditional>
                        <Conditional.NoMatch>
                          {this.props.cartStatus &&
                            FormattedAmount(
                              this.props.cartStatus.totalAnulledAmount,
                            )}
                        </Conditional.NoMatch>
                      </Conditional.Group>
                    </td>
                  </tr>
                </tfoot>
              </Table>
              <div
                className={midas.hasDanger}
                style={{
                  textAlign: 'right',
                  marginTop: '2rem',
                  marginBottom: '-1rem',
                }}
              >
                {this.props.errors.map(error => {
                  return (
                    <div key={error.name}>
                      {error.error && (
                        <p className={midas.formInputHint}>{error.message}</p>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
            <Columns>
              <Column col6>
                <div
                  style={
                    this.props.transactionDetails.paymentMethod?.type !==
                    'SWISH'
                      ? hidden
                      : undefined
                  }
                >
                  <Tooltip
                    style={{ left: '35px', width: '500px' }}
                    content={getText('transactions.transaction.action.tooltip')}
                  >
                    <Button
                      key="addArticleDisabled"
                      type="normal"
                      text={getText('transactions.transaction.action.complete')}
                      disabled
                      dataCy="add-article-disabled-button"
                    />
                  </Tooltip>
                </div>
                <div
                  style={
                    this.props.transactionDetails.paymentMethod?.type ===
                    'SWISH'
                      ? hidden
                      : undefined
                  }
                >
                  <Button
                    key="addArticle"
                    type="normal"
                    text={getText('transactions.transaction.action.complete')}
                    onClick={() => this.props.toggleAddArticle(true)}
                    disabled={this.props.addArticle || !!this.props.action.type}
                    dataCy="add-article-button"
                  />
                </div>
              </Column>
              <Column col6>
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                    justifyContent: 'end',
                  }}
                >
                  <Button
                    type="normal"
                    onClick={() => this.props.onCancel()}
                    disabled={this.props.addArticle || !this.props.action.type}
                  >
                    {getText('default.cancel')}
                  </Button>
                  <Button
                    type="primary"
                    onClick={() =>
                      this.props.handleAction(this.props.action.type)
                    }
                    disabled={
                      this.props.disablePerformButton ||
                      this.props.activeErrors ||
                      this.props.addArticle ||
                      !this.props.action.type
                    }
                    loading={this.props.actionState.loading}
                    dataCy="perform-button"
                  >
                    {getText('default.perform')}
                  </Button>
                </div>
              </Column>
            </Columns>
            <span key="addArticleWrapper" />
          </Column>
        </Columns>
        {this.props.addArticle && (
          <Columns>
            <Column col12>
              <TransactionAddArticle
                orderLimit={this.props.orderLimit}
                orderAmount={this.props.cartStatus.orderAmount}
                loading={this.props.actionState.loading}
                handleAdd={item => this.props.handleComplete(item)}
                toggleAddArticle={state => this.props.toggleAddArticle(state)}
                cartItems={this.props.cartArticles}
              />
            </Column>
          </Columns>
        )}
      </Container>
    ) : (
      <div style={{ margin: '5rem' }} className={midas.loading} />
    )
  }
}

TransactionCartUIEcom.propTypes = {
  cartStatus: PropTypes.object,
  errors: PropTypes.array.isRequired,
  addArticle: PropTypes.bool.isRequired,
  activeErrors: PropTypes.bool.isRequired,
  handleComplete: PropTypes.func.isRequired,
  handleAction: PropTypes.func.isRequired,
  handleNewQuantityChange: PropTypes.func.isRequired,
  handleNewSumChange: PropTypes.func.isRequired,
  checkAvailability: PropTypes.func.isRequired,
  cartArticles: PropTypes.any,
  orderLimit: PropTypes.any.isRequired,
  action: PropTypes.object.isRequired,
  setAction: PropTypes.func.isRequired,
  toggleAddArticle: PropTypes.func.isRequired,
  actionState: PropTypes.object,
  terminalTransaction: PropTypes.object,
  transactionDetails: PropTypes.object,
  disablePerformButton: PropTypes.bool.isRequired,
  sumOperations: PropTypes.bool.isRequired,
  toggleSumOperations: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleNewSumDescriptionChange: PropTypes.func.isRequired,
  handleNewSumVatChange: PropTypes.func.isRequired,
}

TransactionCartUIEcom.defaultProps = {
  actionState: {},
  cartArticles: null,
  cartStatus: null,
  terminalTransaction: null,
  transactionDetails: null,
}

export default TransactionCartUIEcom
